// extracted by mini-css-extract-plugin
export default {"formWrapper":"ProfileSection_formWrapper__h+BpO","title":"ProfileSection_title__HtHGw"};